import * as React from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { useTheme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import { useState } from 'react';
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';
import LoadingScreen from '../../components/LoadingScreen';


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 2 }}>
          <Typography component={'span'} >{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

export default function SellerTabs() {
  const theme = useTheme();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };


  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailReg, setEmailReg] = useState('');
  const [passwordReg, setPasswordReg] = useState('');
  const [confirmPasswordReg, setConfirmPasswordReg] = useState('');
  const [shopName, setShopName] = useState('');
  const [owner, setOwner] = useState('');
  const [otp, setOtp] = useState('');
  const [otpToken, setOtpToken] = useState('');
  const [invalidReg, setInvalidReg] = useState(false);
  const [invalidLogin, setInvalidLogin] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [cookies, setCookie] = useCookies(['accessToken']);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [alertActive, setAlertActive] = useState(false);

  const [show, setShow] = useState({ register: false, otp: false, resetPassword: false, doneResetPassword: false });
  const handleOpenRegister = () => setShow({ register: false, resetPassword: false, });
  const handleOpenOtp = () => setShow({ register: true, resetPassword: false, });
  const handleEndRegister = () => setShow({ otp: true, resetPassword: false, });
  const handleStartOtp = () => setShow({ otp: false, resetPassword: false, });
  const handleOpenResetPassword = () => setShow({ resetPassword: true, register: false, otp: false, doneResetPassword: false });
  const handleCloseResetPassword = () => setShow({ resetPassword: false, register: false, otp: false, doneResetPassword: false });
  const handleDoneResetPassword = () => setShow({ doneResetPassword: true, register: false, otp: false });

  const activateAlert = () => {
    setAlertActive(true);
    setTimeout(() => {
      setAlertActive(false);
    }, 3000);
  }

  const handleSubmitOtp = async (e) => {
    try {
      setIsLoading(true)
      setInvalidReg(false);
      if (emailReg.length < 3 || passwordReg.length < 4) {
        throw new Error('Invalid Input Length!')
      }
      if (passwordReg !== confirmPasswordReg) {
        throw new Error('Password tidak sama')
      }
      const url = `https://w-shop-backend.vercel.app/api/auth/otp?email=${emailReg}`
      const rawResponse = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-type': 'application/json'
        },
      })
      const response = await rawResponse.json();
      if (response.status !== 'success') {
        throw new Error(response.message);
      }
      setOtpToken(response.data.otpToken);
      handleOpenOtp()
      handleStartOtp()
      setIsLoading(false);

    } catch (error) {
      setIsLoading(false);
      setInvalidReg(true);
      setErrorMsg(error.message);
    }
  }

  const handleSubmitRegister = async (e) => {
    try {
      activateAlert();
      setIsLoading(true)
      setInvalidReg(false);
      const url = `https://w-shop-backend.vercel.app/api/auth/register?role=seller`
      const rawResponse = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-type': 'application/json'
        },
        body: JSON.stringify({
          name: emailReg,
          password: passwordReg,
          shopName: shopName,
          owner: owner,
          otp: otp,
          otpToken: otpToken,
        })
      })
      const response = await rawResponse.json();
      if (response.status !== 'success') {
        throw new Error(response.message);
      }
      handleEndRegister();
      setIsLoading(false);
      activateAlert();

    } catch (error) {
      setIsLoading(false);
      setInvalidReg(true);
      setErrorMsg(error.message);
    }
  }


  const handleClick = async (e) => {
    try {
      setIsLoading(true)
      setInvalidLogin(false);
      if (email.length < 3 || password.length < 4) {
        throw new Error('Invalid Input Length!')
      }
      const url = 'https://w-shop-backend.vercel.app/api/auth/login?role=selller'
      const rawResponse = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-type': 'application/json'
        },
        body: JSON.stringify({
          email: email,
          password: password,
        })
      })
      const response = await rawResponse.json();console.log(response.message);
      if (response.status !== 'success') {
        throw new Error(response.message);
      }
      const accessToken = response.data.accessToken;
      const url2 = 'https://w-shop-backend.vercel.app/api/auth/whoami';
      const rawResponse2 = await fetch(url2, {
        method: 'GET',
        headers: {
          'Content-type': 'application/json',
          'Authorization': 'Bearer ' + accessToken,
        },
      })
      const response2 = await rawResponse2.json();
      if (response2.data.role !== 'seller') {
        throw new Error('Akun anda belum terdaftar!')
      }
      navigate('/sellerDashboard');
      setCookie('accessToken', accessToken, { path: '/' });
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setInvalidLogin(true);
      setErrorMsg(error.message);
    }
  }

  const [emailR, setemailR] = useState('');
  const [passwordB, setPasswordB] = useState('');
  const [otpR, setOtpR] = useState('');
  const [invalidR, setInvalidR] = useState('');
  const handleSubmitOtpR = async (e) => {
    try {
      setIsLoading(true)
      setInvalidR(false);
      if (emailR.length < 3 || passwordB < 4) {
        throw new Error('Invalid Input Length!')
      }
      const url = `https://w-shop-backend.vercel.app/api/auth/otp?email=${emailR}`
      const rawResponse = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-type': 'application/json'
        },
      })
      const response = await rawResponse.json();
      if (response.status !== 'success') {
        throw new Error(response.message);
      }
      setOtpToken(response.data.otpToken);
      setIsLoading(false);

    } catch (error) {
      setIsLoading(false);
      setInvalidR(true);
      setErrorMsg(error.message);
    }
  }
  console.log(passwordB);
  const handleSubmitResetPassword = async (e) => {
    try {
      activateAlert();
      setIsLoading(true)
      setInvalidReg(false);
      const url = `https://w-shop-backend.vercel.app/api/auth/password?role=seller`
      const rawResponse = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-type': 'application/json'
        },
        body: JSON.stringify({
          otp: otpR,
          otpToken: otpToken,
          newPassword: passwordB,
        })
      })
      const response = await rawResponse.json();
      if (response.status !== 'success') {
        throw new Error(response.message);
      }
      handleDoneResetPassword()
      setIsLoading(false);
      // navigate('/home')
      activateAlert();

    } catch (error) {
      setIsLoading(false);
      setInvalidR(true);
      setErrorMsg(error.message);
    }
  }

  return (
    <Box className=" ms-auto me-auto d-block px-3">
      <LoadingScreen active={isLoading} />
      <AppBar position="static" className=' mb-2' style={{ background: "white", borderRadius: "10px", color: "black", boxShadow: "none" }} >
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="inherit"
          variant="fullWidth"
          aria-label="full width tabs example"
          className=' py-2 px-4'

        >
          <Tab style={{ fontFamily: "alice", fontSize: 18 }} label="Register" {...a11yProps(0)} />
          <Tab style={{ fontFamily: "alice", fontSize: 18 }} label="Log In" {...a11yProps(1)} />
        </Tabs>
      </AppBar>
      <SwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        <TabPanel value={value} index={0} dir={theme.direction}>
          {
            show.register === false ? (
              <div>
                <div className='bodyTab'>
                  <div className="mb-4">
                    <input type="email" className="form-control in" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder='Email'
                      name='emailReg'
                      onChange={(e) => {
                        setEmailReg(e.target.value);
                      }} />
                  </div>
                  <div className="mb-4">
                    <input type="password" className="form-control in" id="exampleInputPassword1" placeholder='Password'
                      name='passwordReg'
                      onChange={(e) => {
                        setPasswordReg(e.target.value);
                      }} />
                  </div>
                  <div className="mb-4">
                    <input type="password" className="form-control in" id="exampleInputPassword2" placeholder='Confirm Password'
                      name='confirmPasswordReg'
                      onChange={(e) => {
                        setConfirmPasswordReg(e.target.value);
                      }} />
                  </div>
                  <div className="mb-4">
                    <input type="text" className="form-control in" id="exampleInputPassword3" placeholder='Nama Toko'
                      name='shopName'
                      onChange={(e) => {
                        setShopName(e.target.value);
                      }} />
                  </div>
                  <div className="mb-4">
                    <input type="text" className="form-control in" id="exampleInputPassword4" placeholder='Owner'
                      name='owner'
                      onChange={(e) => {
                        setOwner(e.target.value);
                      }} />
                  </div>
                </div>
                <button className="btn w-100 bin p-2 mt-3" style={{ background: "rgba(0, 102, 255, 0.45)", color: "white", minHeight: 50 }}
                  onClick={
                    () => {
                      handleSubmitOtp()
                    }
                  }
                >Register</button>
                {(invalidReg) ?
                  <span data-testid='login-err-msg' className='error-msg'>{errorMsg}</span> : ''
                }
              </div>
            ) : show.otp === false ? (
              <div>
                <p className='kodeOtp'>Masukan Kode OTP</p>
                <div className="mb-4">
                  <input type="text" className="form-control in" id="otp" aria-describedby="otp" placeholder='Otp'
                    name='otp'
                    onChange={(e) => {
                      setOtp(e.target.value);
                    }} />
                  <p className='cekEmail'>Silahkan cek email anda</p>
                </div>
                {(invalidReg) ?
                  <span data-testid='login-err-msg' className='error-msg'>{errorMsg}</span> : ''
                }
                <div>
                  <button className="btn  bin p-2" style={{ background: "rgba(0, 102, 255, 0.45)", color: "white", width: '40%' }}
                    onClick={
                      () => {
                        handleOpenRegister()
                      }
                    }
                  >Kembali</button>
                  <button className="btn  bin p-2 ms-5" style={{ background: "rgba(0, 102, 255, 0.45)", color: "white", width: '40%' }}
                    onClick={
                      () => {
                        handleSubmitRegister()
                      }
                    }
                  >Register</button>
                </div>
              </div>
            ) : (
              <p className='kodeOtp text-center text-primary'>Selamat akun anda telah terdaftar silakan login untuk masuk ke akun anda</p>
            )}
        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction}>
          {
            show.resetPassword === false ? (
              <div>
                <div className='bodyTab'>
                  <div className="my-3">
                    <input type="email" className="form-control in" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder='Email'
                      name='email'
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                    />
                  </div>
                  <div className="my-4">
                    <input type="password" className="form-control in" id="exampleInputPassword1" placeholder='Password'
                      name='password'
                      onChange={(e) => {
                        setPassword(e.target.value);
                      }}
                    />
                  </div>
                  <button className='btn border-none text-primary' style={{ fontSize: 13 }}
                    onClick={
                      () => {
                        handleOpenResetPassword()
                      }
                    }
                  >Lupa Password</button>
                </div>
                <button  className="btn w-100 bin p-2 " style={{ background: "rgba(0, 102, 255, 0.45)", color: "white", minHeight: 50 }}
                  onClick={
                    handleClick}
                >Log In</button>
                  {(invalidLogin) ?
                  <span data-testid='login-err-msg' className='error-msg'>{errorMsg}</span> : ''
                }
              </div>
            ) : show.doneResetPassword === false ? (
              <div>
                <div className="mb-4">
                  <input type="email" className="form-control in" id="emailResetPassword" aria-describedby="emailResetPassword" placeholder='Email'
                    name='emailResetPassword'
                    onChange={(e) => {
                      setemailR(e.target.value);
                    }} />
                </div>
                <div className="mb-4">
                  <input type="password" className="form-control in" id="passwordBaru" aria-describedby="passwordBaru" placeholder='Password Baru'
                    name='opasswordBaru'
                    onChange={(e) => {
                      setPasswordB(e.target.value);
                    }} />
                </div>
                <div className="mb-4 d-flex">
                  <input type="text" className="form-control in" id="otpreset" aria-describedby="reset" placeholder='Otp'
                    name='otpresetotp'
                    onChange={(e) => {
                      setOtpR(e.target.value);
                    }} />
                  <button className="btn btn-outline-primary  bin p-2" onClick={
                    () => {
                      handleSubmitOtpR();
                    }
                  }>OTP</button>
                </div>
                <p className='cekEmail mt-1'>Klik tombol OTP dan cek email anda</p>
                <div>
                  <button className="btn  bin p-2" style={{ background: "rgba(0, 102, 255, 0.45)", color: "white", width: '40%' }}
                    onClick={
                      () => {
                        handleCloseResetPassword()
                      }
                    }
                  >Kembali</button>
                  <button className="btn  bin p-2 ms-5" style={{ background: "rgba(0, 102, 255, 0.45)", color: "white", width: '40%' }}
                    onClick={
                      () => {
                        handleSubmitResetPassword()
                      }
                    }
                  >Reset</button>
                </div>
                {(invalidR) ?
                  <span data-testid='login-err-msg' className='error-msg'>{errorMsg}</span> : ''
                }
              </div>
            ) : (
              <div>
                <p className='kodeOtp text-center text-primary mb-5'>Reset Password sukses silakan login untuk masuk ke akun anda</p>
                <button className="btn  bin p-2 mt-5 ms-auto d-block me-auto" style={{ background: "rgba(0, 102, 255, 0.45)", color: "white", width: '40%' }}
                  onClick={
                    () => {
                      handleCloseResetPassword()
                    }
                  }
                >Log In</button>
              </div>
            )
          }
        </TabPanel>
      </SwipeableViews>
    </Box>
  );
}
